export interface PreparedTusUpload {
  videoUid: string;
  options: {
    uploadUrl?: string;
    endpoint?: string;
    headers?: Record<string, string>;
    metadata: Record<string, string>;
  };
}

/**
 * Готовит опции tus.Upload под конкретного провайдера.
 * Cloudflare: бэкенд уже создал tus-ресурс, его адрес идёт в uploadUrl.
 * Bunny: ресурс создаёт сам клиент на общем endpoint, авторизация лежит
 * в заголовках, filetype и title обязательны в метаданных.
 */
export function buildTusOptions(input: {
  file: File;
  direct?: { uploadUrl: string; videoUid: string } | null;
  tus?: {
    endpoint: string;
    videoUid: string;
    headers: { name: string; value: string }[];
  } | null;
}): PreparedTusUpload {
  if (input.tus) {
    return {
      videoUid: input.tus.videoUid,
      options: {
        endpoint: input.tus.endpoint,
        headers: Object.fromEntries(
          input.tus.headers.map((header) => [header.name, header.value])
        ),
        metadata: {
          filetype: input.file.type || "video/mp4",
          title: input.file.name,
        },
      },
    };
  }

  if (input.direct) {
    return {
      videoUid: input.direct.videoUid,
      options: {
        uploadUrl: input.direct.uploadUrl,
        metadata: { filename: input.file.name, filetype: input.file.type },
      },
    };
  }

  throw new Error("NO_UPLOAD_TARGET");
}
